import {PREVENT_SCROLL_CLASSNAME} from '../constant/talkViewerConstant';

export function enableScroll() {
  if (typeof window === 'undefined') {
    return;
  }
  document.body.classList.remove(PREVENT_SCROLL_CLASSNAME);
}
